module.exports = __webpack_public_path__ + "static/media/time-active.c43dde4f.svg";